import { render, staticRenderFns } from "./CollectionEditor.vue?vue&type=template&id=6e9defb8&scoped=true"
import script from "./CollectionEditor.vue?vue&type=script&lang=js"
export * from "./CollectionEditor.vue?vue&type=script&lang=js"
import style0 from "./CollectionEditor.vue?vue&type=style&index=0&id=6e9defb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9defb8",
  null
  
)

export default component.exports